import type { CrudSearchItem, CrudTableColumn } from '@/types/crud-config'

export const reminderTypeOptions = [
  { label: '公共', value: 0 },
  { label: '敏感词', value: 1 },
  { label: '课程邀约', value: 2 },
  { label: '定金', value: 3 }
]

export const valueTypeOptions = [
  { label: '布尔值', value: 'BOOLEAN' },
  { label: '整数', value: 'INTEGER' },
  { label: '字符串', value: 'STRING' },
  { label: 'JSON', value: 'JSON' }
]

export const realtimeReminderSearchItems: CrudSearchItem[] = [
  {
    label: '企微主体ID',
    prop: 'corpId',
    type: 'input',
    clearable: true,
    placeholder: '为空时查询全部主体'
  },
  {
    label: '提醒类型',
    prop: 'reminderType',
    type: 'select',
    clearable: true,
    placeholder: '请选择提醒类型',
    options: reminderTypeOptions
  }
]

export const realtimeReminderTableColumns: CrudTableColumn[] = [
  { label: '配置项编码', prop: 'configKey', minWidth: 160, showOverflowTooltip: true },
  { label: '配置项值', prop: 'configValue', minWidth: 180, showOverflowTooltip: true },
  { label: '企微主体ID', prop: 'corpId', minWidth: 140, slot: 'corpId' },
  { label: '提醒类型', prop: 'reminderType', minWidth: 100, slot: 'reminderType' },
  { label: '值类型', prop: 'valueType', minWidth: 100, slot: 'valueType' },
  { label: '状态', prop: 'enabled', minWidth: 90, slot: 'enabled' },
  { label: '配置说明', prop: 'description', minWidth: 180, showOverflowTooltip: true },
  { label: '最后修改人', prop: 'updatedBy', minWidth: 110, showOverflowTooltip: true },
  { label: '最后修改时间', prop: 'updatedAt', minWidth: 170, showOverflowTooltip: true },
  { label: '版本号', prop: 'versionNo', minWidth: 90, align: 'center' },
  { label: '操作', slot: 'rowActions', width: 160, fixed: 'right' }
]
